import React, { useState, useEffect, useRef } from "react";

// components
import { Media, FoodTotal } from "../common";

// assets
import commentIcon from "bodycodi/cmap/app/img/icon_comment.png";
import OneToOneIcon from "bodycodi/cmap/app/svg/community_onetoone_icon.svg";
import GroupIcon from "bodycodi/cmap/app/svg/community_group_icon.svg";

const CommunityListCardDetails = ({ details, handleClickComment }: any) => {
  const descriptionRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [seeMore, setSeeMore] = useState<boolean>(false);

  useEffect(() => {
    if (details === null) {
      return;
    }
    const line = 3;
    const style = getComputedStyle(contentRef.current!)!;
    const lineHeight = Math.ceil(parseInt(style.lineHeight.replace("px", "")));
    const height = Math.ceil(parseInt(style.height.replace("px", "")));
    if (height > lineHeight * line) {
      setSeeMore(true);
      descriptionRef.current!.style.height = lineHeight * line + "px";
    } else {
      setSeeMore(false);
    }
  }, [details]);

  return (
    <div className={"comunity-content-body"}>
      {details.postType === "MEMBER_FOODLENS_UPLOAD" ? (
        <FoodTotal foodLensInfo={details.foodLensInfo} isList={true} />
      ) : (
        <div className="media preview thumbnail">
          <Media files={details.files} isDetail={false} />
        </div>
      )}

      <div className="decs" ref={descriptionRef}>
        <div className="text" ref={contentRef}>
          {details?.uploadContent}
        </div>
        {seeMore && <div className="more">...더보기</div>}
      </div>

      <div className="comunity-content-footer">
        <div className="commnet" onClick={handleClickComment}>
          <img src={commentIcon} />
          {details.commentCount > 0 ? `댓글 ${details.commentCount}` : `댓글쓰기`}
        </div>

        {details?.members.length > 1 ? <img src={GroupIcon} /> : <img src={OneToOneIcon} />}
      </div>
    </div>
  );
};

export default CommunityListCardDetails;
